import React from 'react';
import './FootballFieldPlayers.css'


function FieldInfo(props) {

    const { strPlayer, strCutout, strTeam } = props;





    return (
        <div className='playerMoreInfo'>
            <div className='TeamInfo'>

                <img className='playerPhotoInfo' src={strCutout} alt={`${strPlayer}`} />
                <h1 className='playerNameInfo'>{strPlayer}</h1>
                <h1 className='playerTeamInfo'>{strTeam}</h1>
            </div>
        </div>
    )
}



export default FieldInfo;